import { render } from "./IconPhoto.vue?vue&type=template&id=30c5ef92"
const script = {}

import exportComponent from "/var/www/metiznew/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__